import { supabase } from './supabase'
import { aceitouNoRegisto, limparAceitacaoNoRegisto } from './consentimentoRegisto'

export { marcarAceitacaoNoRegisto } from './consentimentoRegisto'

// Aceitação dos Termos de Uso e da Política de Privacidade pelo cliente
// (26/10/2026). A prova fica na BD (consentimentos), com a versão em vigor,
// a data, a origem, o IP e o navegador — não aqui.

/** Políticas que o cliente da sessão ainda não aceitou na versão em vigor. */
export async function politicasEmFalta(): Promise<string[]> {
  const { data, error } = await supabase.rpc('politicas_em_falta_cliente')
  if (error) throw error
  return (data as string[] | null) ?? []
}

export async function aceitarPoliticas(origem: 'registo_site' | 'aviso_site'): Promise<void> {
  const { error } = await supabase.rpc('aceitar_politicas_cliente', { p_origem: origem, p_user_agent: navigator.userAgent })
  if (error) throw error
  limparAceitacaoNoRegisto()
}

/**
 * Verifica ao entrar: se faltar aceitar e a pessoa marcou os vistos no registo
 * neste navegador, regista sem perguntar de novo. Devolve se é preciso mostrar o aviso.
 */
export async function verificarAoEntrar(): Promise<boolean> {
  const emFalta = await politicasEmFalta()
  if (emFalta.length === 0) return false
  if (aceitouNoRegisto()) {
    await aceitarPoliticas('registo_site')
    return false
  }
  return true
}
